import { render } from "./DestinationsMisc.vue?vue&type=template&id=359bce9c"
import script from "./DestinationsMisc.vue?vue&type=script&lang=js"
export * from "./DestinationsMisc.vue?vue&type=script&lang=js"
script.render = render

export default script